<template>
  <span class="action-header-selection">
    <slot></slot>
  </span>
</template>

<script>
  export default {
    name: 'ActionHeaderSelection',
    compatConfig: {
      MODE: 3,
    },
  };
</script>

<style scoped lang="scss">
  :deep(option:first-child) {
    display:none;
  }
</style>
